<div class="tp-page">
  <tp-page-header
    title="Reportes"
    subtitle="Elegí el tipo de reporte, completá los filtros y descargalo"
  ></tp-page-header>

  <section class="tp-card reporting-container">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Reporte de tareas con final de obra">
        <app-report-final></app-report-final>
      </mat-tab>
      <mat-tab label="Reporte de tareas con órdenes de montaje">
        <app-report-ao></app-report-ao>
      </mat-tab>
    </mat-tab-group>
  </section>
</div>
